// *Label Rejected [Label Rejected, Label Rejected (Awaiting Courier) & Label Rejected (Reported)] 120, 121, 122
// *Label Pending 104
export const UNSHIPPED_STATUS_IDS = [104, 120, 121, 122];
